import { render, staticRenderFns } from "./new_dwg_box.vue?vue&type=template&id=47ed135c&scoped=true&"
import script from "./new_dwg_box.vue?vue&type=script&lang=js&"
export * from "./new_dwg_box.vue?vue&type=script&lang=js&"
import style0 from "./new_dwg_box.vue?vue&type=style&index=0&id=47ed135c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed135c",
  null
  
)

export default component.exports